import { FileSignatureController } from '@shared/controllers/file-signature.controller';
import { getPrivateAttachmentUrl } from '@shared/helpers/private-attachment-url.helper';
import {
  ProjectSiteDiaryEntry,
  ProjectSiteDiaryMedia
} from '@modules/projects/shared/interfaces/project-site-diary.interface';

export interface ProjectSiteDiaryMediaView extends ProjectSiteDiaryMedia {
  isImageFile: boolean;
  isVideoFile: boolean;
  thumbnailUrl: string;
  fileUrl: string;
}

export function mapProjectSiteDiaryMedia(
  media: ProjectSiteDiaryEntry['media'],
  signatureController: FileSignatureController
): ProjectSiteDiaryMediaView[] {
  return getProjectSiteDiaryMediaItems(media)
    .filter((item) => !item.deleted && !!item.file)
    .map((item) => mapMedia(item, signatureController));
}

export function getProjectSiteDiaryMediaItems(media: ProjectSiteDiaryEntry['media']): ProjectSiteDiaryMedia[] {
  if (Array.isArray(media)) return media;
  if (media && typeof media === 'object') return Object.values(media);
  return [];
}

function mapMedia(media: ProjectSiteDiaryMedia, signatureController: FileSignatureController): ProjectSiteDiaryMediaView {
  const type = String(media.type || '').toLowerCase();
  const isImageFile = !!media.isImage || type.startsWith('image/');
  const isVideoFile = !!media.isVideo || type.startsWith('video/');

  return {
    ...media,
    isImageFile,
    isVideoFile,
    thumbnailUrl: getPrivateAttachmentUrl(media.file, signatureController, {
      poster: isVideoFile,
      width: 200,
      height: 200
    }),
    fileUrl: getPrivateAttachmentUrl(media.file, signatureController)
  };
}
